// extracted by mini-css-extract-plugin
export var imageHuge = "TwoSideImageAndText-module--imageHuge--7e154";
export var imageShadow = "TwoSideImageAndText-module--imageShadow--033b6";